import DatePicker from "./src/index"
// import DatePicker from "./src/main"

DatePicker.name = "VocDatePicker"
/* istanbul ignore next */
DatePicker.install = function install(Vue) {
  Vue.component(DatePicker.name, DatePicker)
}

export default DatePicker
